import useLocalStorage from "../lib/use-local-storage";
import isTokenExpired from "./isTokenExpired";
export default function useStoredToken() {
  const [token, setToken] = useLocalStorage("mergon-token", null);
  return [token && isTokenExpired(token) ? null : token, setToken];
}
